var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"fab":"","dark":"","small":"","elevation":"0","color":"yellow darken-2","title":"Show Blast Packet Tasks"},on:{"click":_vm.onHighlightBlastPacket}},[_c('v-icon',[_vm._v("mdi-flashlight")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }